// @noflow
import { httpGet } from '~/core/api/helpers/helpers.api';
import url from 'url';

export const getEvents = (eventType, id, from, to) => {
    const productUrl = url.format({
        pathname: `products/${eventType}/${id}/events`,
        query: {
            from,
            to
        }
    });
    return httpGet(productUrl);
};



// WEBPACK FOOTER //
// ./src/core/api/sensor-events/index.js